document.addEventListener("DOMContentLoaded", () => {
    window.addEventListener("load", () => {
        gsap.registerPlugin(ScrollTrigger)

        const fleches = gsap.utils.toArray('.fleche-titre');
        fleches.forEach(fleche => {
            gsap.from(fleche.querySelector('.fleche'), {
                scrollTrigger: {
                    trigger: fleche,
                    markers: false,
                    start: "bottom+=25% bottom",
                    toggleActions: "play pause resume reset"
                },
                right: "100vw",
                duration: 0.6
            })
        })
    });
});